<script setup lang="ts">
import { computed, useAttrs } from 'vue';
defineOptions({ inheritAttrs: false, name: 'EGS_Skeleton' });
const props = withDefaults(defineProps<{ width?: string; height?: string; borderRadius?: string }>(), { width: '100%', height: '1rem', borderRadius: '' });
const attrs = useAttrs();
const styles = computed(() => ({ width: props.width, height: props.height, borderRadius: props.borderRadius || undefined }));
</script>

<template><div v-bind="attrs" :style="styles" :class="['animate-pulse rounded-md bg-surface-200 dark:bg-surface-700', attrs['class']]" aria-hidden="true"></div></template>
